// import { GoArrowUpRight } from "react-icons/go";
// import images from "../../assets/images/Constant";
// import footerData from "../../data/footer.json";

// export default function Footer() {

//   const services = footerData?.services || [];
//   const links = footerData?.links || [];
//   const bottomLinks = footerData?.bottom?.extraLinks || [];

  

//   return (
//     <footer
//       className="text-white pt-20"
//       style={{ backgroundImage: `url(${images.footer})` }}
//     >

//       {/* NEWSLETTER */}

//       <div className="max-w-[1200px] mx-auto px-6 -mt-32">

//         <div
//           className="bg-primary rounded-lg p-8 flex items-center justify-between"
//           style={{ backgroundImage: `url(${images.formbg})` }}
//         >

//           <div className="flex items-center gap-4">

//             <img src={images.msg} className="w-16" />

//             <h3 className="text-[40px] leading-tight font-semibold">
//               {footerData?.newsletter?.title}
//             </h3>

//           </div>

//           <div className="flex gap-4">

//             <input
//               type="email"
//               placeholder={footerData?.newsletter?.placeholder}
//               className="px-4 py-3 w-[280px] text-black rounded-md outline-none"
//             />

//             <button className="bg-dark px-8 py-3 rounded-md text-white flex items-center gap-2 ">
//               {footerData?.newsletter?.button}
//                <GoArrowUpRight />
//             </button>

//           </div>

//         </div>

//       </div>


//       {/* MAIN FOOTER */}

//       <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-4 gap-10">

//         {/* COLUMN 1 */}

//         <div
//           className="bg-dark/80 shadow-lg p-8"
//           style={{ backgroundImage: `url(${images.formbg})` }}
//         >

//           <img src={images.logo2} className="mb-4 w-36" />

//           <p className="text-sm text-gray-300 mb-4">
//             {footerData?.about?.description}
//           </p>
//         <div className="flex gap-3 cursor-pointer">
//   <img src={images.fb} alt="" className="w-8 h-8" />
//  <img src={images.insta} alt="" className="w-8 h-8" />
//   <img src={images.Twitter} alt="" className="w-8 h-8" /> 
//   <img src={images.linkdin} alt=""className="w-8 h-8" /> 


//       </div>

//         </div>


//         {/* COLUMN 2 */}

//         <div>

//           <h4 className="font-semibold text-[#C5C5C5] text-subheading pt-10 pb-5">
//             Our Services
//           </h4>

//           <ul className="space-y-2 text-[#C5C5C5] text-body">

//             {services.map((item, i) => (
//               <li key={i}>{item}</li>
//             ))}

//           </ul>

//         </div>


//         {/* COLUMN 3 */}

//         <div>

//           <h4 className="font-semibold text-[#C5C5C5] text-subheading pt-10 pb-5">
//             Useful Links
//           </h4>

//           <ul className="space-y-2 text-[#C5C5C5] text-body">

//             {links.map((item, i) => (
//               <li key={i}>{item}</li>
//             ))}

//           </ul>

//         </div>

//         {/* COLUMN 4 */}

// <div>

//   <h4 className="font-semibold text-[#C5C5C5] text-subheading pt-10 pb-5">
//     Contact Info
//   </h4>

//   {footerData?.contact?.map((item, i) => (

//     <div key={i} className="flex items-start gap-3 mb-3">

//       <img
//   src={images[item.icon]}
//   className="w-8 h-8 mt-1"
//   alt=""
// />

//       <p className="text-[#C5C5C5] text-body">
//         {item.text}
//       </p>

//     </div>

//   ))}

// </div>      </div>


//       {/* BOTTOM BAR */}

//       <div className="border-t text-light py-6">

//         <div className="max-w-[1200px] mx-auto px-6 flex justify-between text-sm text-gray-400">

//           <p>{footerData?.bottom?.copyright}</p>

//           <div className="flex gap-6">

//             {bottomLinks.map((item, i) => (
//               <p key={i}>{item}</p>
//             ))}

//           </div>

//         </div>

//       </div>

//     </footer>
//   );
// }


import images from "../../assets/images/Constant";
import footerData from "../../data/footer.json";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import serviceData from "../../data/service.json";

export default function Footer() {

  const services = footerData?.services || [];
  const links = footerData?.links || [];
  const bottomLinks = footerData?.bottom?.extraLinks || [];

  const linkToPath = {
    // Blogs: "/blog",
    // Blog: "/blog",
    About: "/about",
    "About Us": "/about",
    Services: "/service",
    Service: "/service",
    Career: "/career",
    Contacts: "/contact",
    Contact: "/contact",
    Faqs: "/faqs",
    // "Privacy Policy": "/privacy-policy",
  };
  const getPath = (label) => linkToPath[label] || "/";

  const normalize = (s) =>
    String(s || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();

  const serviceIdByLabel = (label) => {
    const labelNorm = normalize(label);
    const list = serviceData?.services || [];

    const match =
      list.find((s) => normalize(s.title).includes(labelNorm)) ||
      list.find((s) => labelNorm.includes(normalize(s.title)));

    return match?.id || null;
  };

  

  return (
    <footer
      className="text-white"
      style={{ backgroundImage: `url(${images.footer})` }}
    >
      <div className="">
        <div className="px-4 sm:px-6 lg:px-12 xl:px-20 max-w-[1400px] mx-auto pt-10 sm:pt-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-10">
            {/* COLUMN 1 */}
            <div className="lg:col-span-4 bg-[#062E39]/70 border border-white/10 py-10 px-6 sm:py-16 sm:px-8 lg:py-20">
              <img src={images.logo2} alt="logo" className="w-44" />
              <p className="mt-5 text-sm text-white/70 leading-relaxed">
                {footerData?.about?.description}
              </p>
 <div className="flex gap-3 cursor-pointer py-12">
  <img src={images.fb} alt="" className="w-10 h-10" />
 <img src={images.insta} alt="" className="w-10 h-10" />
  <img src={images.linkdin} alt=""className="w-10 h-10" /> 


      </div>
              {/* <div className="mt-6 flex gap-3">
                <a
                  href="/"
                  className="w-9 h-9 bg-[#21A3FF] text-white inline-flex items-center justify-center"
                  aria-label="Facebook"
                >
                  f
                </a>
                <a
                  href="/"
                  className="w-9 h-9 bg-[#21A3FF] text-white inline-flex items-center justify-center"
                  aria-label="Instagram"
                >
                  in
                </a>
                <a
                  href="/"
                  className="w-9 h-9 bg-[#21A3FF] text-white inline-flex items-center justify-center"
                  aria-label="LinkedIn"
                >
                  li
                </a>
              </div> */}
            </div>

            {/* COLUMN 2 */}
            <div className="lg:col-span-3 pt-8 md:pt-12 lg:pt-16 px-0 sm:px-4 lg:px-6">
              <h4 className="font-semibold text-white text-subheading">Our Services</h4>
              <ul className="mt-6 space-y-3 text-description text-white/70">
                {services.map((item, i) => {
                  const id = serviceIdByLabel(item);
                  return (
                    <li key={i}>
                      {id ? (
                        <Link to={`/service/${id}`} className="hover:text-white">
                          {item}
                        </Link>
                      ) : (
                        <span className="cursor-default">{item}</span>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* COLUMN 3 */}
            <div className="lg:col-span-2 pt-8 md:pt-12 lg:pt-16">
              <h4 className="font-semibold text-white text-subheading">Useful Links</h4>
              <ul className="mt-6 space-y-3 text-description text-white/70">
                {links.map((item, i) => (
                  <li key={i}>
                    <Link to={getPath(item)} className="hover:text-white">
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* COLUMN 4 */}
            <div className="lg:col-span-3 pt-8 md:pt-12 lg:pt-16 ml-0 lg:ml-10">
  <h4 className="font-semibold text-white text-subheading">Contact Info</h4>

  <div className="mt-6 space-y-6 text-description text-white/70">

    {/* ADDRESS */}
    <div className="flex items-start gap-4">
      <span className="w-9 h-9 flex-shrink-0 rounded-full border border-white/20 flex items-center justify-center text-white">
        <FaMapMarkerAlt />
      </span>
      <p className="leading-relaxed break-words">
        {footerData?.contact?.[0]?.text}
      </p>
    </div>

    {/* PHONE */}
    <div className="flex items-start gap-4">
      <span className="w-9 h-9 flex-shrink-0 rounded-full border border-white/20 flex items-center justify-center text-white">
        <FaPhoneAlt />
      </span>
      <p className="leading-relaxed break-words place-self-center">
        {footerData?.contact?.[1]?.text}
      </p>
    </div>

    {/* EMAIL */}
    <div className="flex items-start gap-4">
      <span className="w-9 h-9 flex-shrink-0 rounded-full border border-white/20 flex items-center justify-center text-white">
        <FaEnvelope />
      </span>
      <p className="leading-relaxed break-words place-self-center">
        {footerData?.contact?.[2]?.text}
      </p>
    </div>

  </div>
</div>
</div>

          {/* BOTTOM BAR */}
          <div className=" py-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/60">
            <p>{footerData?.bottom?.copyright}</p>
            <div className="flex gap-6">
              {bottomLinks.map((item, i) => (
                <Link key={i} to={getPath(item)} className="hover:text-white">
                  {item}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

    </footer>
  );
}